import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PERMISSIONS from "../utils/wkCommon";
import { hasUmatPermissionAsync } from "../utils/permissionsAsync";
import { getUser } from "../utils/auth";
import { useLocation } from "react-router-dom";
import { isZh } from "../utils/language";

export default function AgendaCrossNavMenu({ agendaId, onClose, hasPreRegForm = false }) {
	const location = useLocation();
  const path = location.pathname.toLowerCase();

  const isAgendaBook = path.includes("/agendabook");
  const isPresensi   = path.includes("/presensi");
  const isReport     = path.includes("/abr");
  const isPreReg     = path.includes("/prereg");
  const isPreRegList     = path.includes("/prereglist");

	const history = useHistory();
  const user = getUser();
  const email = user?.email || user?.LoginEmail;

  const [perms, setPerms] = useState({
    presensi: false,
    agendaBook: false,
    report: false,
    prereg: false,
    prereglist: false,
  });

  useEffect(() => {
    let mounted = true;

    async function load() {
      const [
        p1,
        p2,
        p3,
        p4, 
        p5
      ] = await Promise.all([
        hasUmatPermissionAsync(email, PERMISSIONS.EVENTPARTICIPANT_READ),
        hasUmatPermissionAsync(email, PERMISSIONS.AGENDA_RUNDOWN_READ),
        hasUmatPermissionAsync(email, PERMISSIONS.AGENDA_EXPENSE_READ),
        hasUmatPermissionAsync(email, PERMISSIONS.AGENDA_PREREGFORM_EDITOR),
        hasUmatPermissionAsync(email, PERMISSIONS.AGENDA_PREREG_READ),
      ]);

      if (!mounted) return;

      setPerms({
        presensi: !!p1,
        agendaBook: !!p2,
        report: !!(p2 || p3),
        prereg: !!p4,
        prereglist: !!p5,
      });
    }

    load();
    return () => { mounted = false };
  }, [email]);

  function go(path) {
    history.push(path);
    onClose && onClose();
  }

  return (
    <>
    <style>{`
    .action-menu{
			position: absolute;
			top: calc(100% + 0.4rem);
			right: 0;
			z-index: 999;

			background: #fff;
			border-radius: 0.75rem;
			box-shadow: 0 10px 25px rgba(0,0,0,0.15);
			min-width: 180px;
			padding: 0.4rem 0;
		}

    .menu-item{
			padding: 0.6rem 0.9rem;
			cursor: pointer;
			white-space: nowrap;
    }

    .menu-item:hover{
	    background: #f1f5f9;
    }        

		.menu-section-label{
			font-size: 0.7rem;
			font-weight: 600;
			color: #64748b;

			padding: 0.4rem 0.9rem 0.2rem;
			margin-top: 0.2rem;

			text-transform: uppercase;
			letter-spacing: 0.04em;
		}			

    .menu-item {
      font-weight: 500 !important;
      color: #0f172a !important
    }
  `}</style>
  <div className="menu-section-label">Navigate</div>		
		{!isPresensi && perms.presensi && (
			<div className="menu-item" onClick={() => go(`/Presensi/${agendaId}`)}>
				{isZh() ? "簽到資料" : "Data Presensi"}
			</div>
		)}

		{!isAgendaBook && perms.agendaBook && (
			<div className="menu-item" onClick={() => go(`/AgendaBook/${agendaId}`)}>
				{isZh() ? "議程簿" : "Buku Agenda"}
			</div>
		)}

		{!isReport && perms.report && (
			<div className="menu-item" onClick={() => go(`/abr/${agendaId}`)}>
				{isZh() ? "報表預覽" : "Laporan Agenda"}
			</div>
		)}

		{!isPreReg && perms.prereg && (
			<div className="menu-item" onClick={() => go(`/PreRegFormSetup/${agendaId}`)}>
				{isZh() ? "報名表設定" : "Setup Form Registrasi"}
			</div>
		)}

		{!isPreRegList && perms.prereglist && hasPreRegForm && (
			<div className="menu-item" onClick={() => go(`/prereglist/${agendaId}`)}>
				{isZh() ? "預先報名名單" : "List Nama Pra-Registrasi"}
			</div>
		)}
    </>

  );
}